"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_TWO_FACTOR_MAPPER = void 0;
var _authentication = require("../../types/authentication");
const EVENT_TWO_FACTOR_MAPPER = exports.EVENT_TWO_FACTOR_MAPPER = {
  [_authentication.ETwoFactorType.Phone]: 'phone_',
  [_authentication.ETwoFactorType.Email]: 'email_'
};